/* eslint-disable class-methods-use-this */
import _ from 'lodash';

import * as api from '../../../../utils/apiClient';
import { restructureInfoMaterialsModel } from './restructuring';

class InfoMaterialsService {
  async getInfoMaterialById(state, infoMaterialId) {
    const response = await api.get(`/info-materials/${infoMaterialId}`, {});
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: _.keyBy(
        _.map([responseJson.data], item =>
          restructureInfoMaterialsModel(state, item)
        ),
        'tagUrl'
      )
    };
  }
}

export default new InfoMaterialsService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/infoMaterials/services/InfoMaterialsService/InfoMaterialsService.js